import React, { useEffect, useState } from "react";
import "./WorkspacesDetailsHistory.css";
import { useDispatch, useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import MyHistory from "./MyHistory/MyHistory";
import WorkspacesHistory from "./WorkspacesHistory/WorkspacesHistory";
import { workspaces_Quick_Action_SelfHandler } from "../../../../Redux/Actions/user/WorkspaceQuickSelf";
import { workspaces_Quick_Action_HistoryHandler } from "../../../../Redux/Actions/user/WorkspaceQuickHistory";
const WorkspacesDetailsHistory = () => {
  const parms = useParams();
  const workspace_id = parms.id;
  let dispatch = useDispatch();
  const workspaceQuickactionsHistoryData = useSelector(
    (state) =>
      state?.workspaces_QuickHistory_Data?.workspace_quickactionsHistory_data
        ?.data
  );
  const workspaceQuickactionsSelfData = useSelector(
    (state) =>
      state?.workspaces_QuickSelf_Data?.workspace_quickactionsSelf_data?.data
  );
  let [selectedItem, setSelectedItem] = useState(0);
  const TabsItem = [
    {
      name: `My History (${workspaceQuickactionsSelfData?.total || 0})`,
      icon: <FaUser />,
    },
    {
      name: `Workspace History (${
        workspaceQuickactionsHistoryData?.total || 0
      })`,
      icon: <FaUsers />,
    },
  ];

  const handleClick = (index) => {
    setSelectedItem(index);

    //gtm
    window.dataLayer.push({
      event: "workspace History",
      buttonName: "workspace History",
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
  };

  useEffect(() => {
    if (workspace_id) {
      dispatch(workspaces_Quick_Action_HistoryHandler(workspace_id, "", ""));
      dispatch(workspaces_Quick_Action_SelfHandler(workspace_id, "", ""));
    }
  }, [workspace_id]);
  return (
    <div className="workspace-container">
      <div className="workspace-details-history-main-1">
        <div className="top-option-history-work">
          {TabsItem?.map((item, index) => (
            <div
              key={index}
              onClick={() => handleClick(index)}
              className={
                index === selectedItem
                  ? "underline-workspace-history-item"
                  : "non-undeline-history-item"
              }
            >
              {item.icon} {item.name}
            </div>
          ))}
        </div>
      </div>
      <div className="detail-history-div">
        {selectedItem === 0 ? <MyHistory /> : <WorkspacesHistory />}
      </div>
    </div>
  );
};

export default WorkspacesDetailsHistory;
